import { useEffect, useState } from 'react'
import { Grid, Link } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useInitReq } from '../../../InitReq'
import { ISettingsItem, useSettings } from "../../../Settings"
import { useTranslation } from "../../../i18n"
import { ReactComponent as RightArrow } from '../../../assets/icons/linedRightArrow.svg'
import StepDefault from './steps/StepDefault'
import { ReactComponent as CheckIcon } from '../../../assets/icons/checkIcon.svg'
import { ReactComponent as WhatsAppIcon } from '../../../assets/icons/whatsappIcon.svg'
/* STEP 2 */
import ESimModal from './steps/ESimModal'
import { ReactComponent as ESimIcon } from '../../../assets/icons/eSimIcon.svg'
/* STEP 3 */
import PortabilityModal from './steps/PortabilityModal'
import { ReactComponent as PortabilityIcon } from '../../../assets/icons/portabilityIcon.svg'
/* STEP 4 */
import SmartControl from './steps/SmartControl'
import { ReactComponent as SmartControlIcon } from '../../../assets/icons/smartControlIcon.svg'

export default function StepperConfig({ name, variables }: ISettingsItem) {
  const navigate = useNavigate()
  const location = useLocation()
  const { currentUserConfigs, loadingUserConfigs } = useInitReq()
  const { socials, pageTitle } = useSettings()
  const { t } = useTranslation()
  const [currentPath, setCurrentPath] = useState<string>()
  const [step2, setStep2] = useState('active')
  const [step3, setStep3] = useState('disabled')
  const [step4, setStep4] = useState('disabled')
  const [step2Modal, setStep2Modal] = useState(false)
  const [step3Modal, setStep3Modal] = useState(false)
  const [step4Modal, setStep4Modal] = useState(false)
  const defaultTextArray = [
    'none', // índice 0
    '', // índice 1 - a URL do WhatsApp será construída dinamicamente
    t.page3.stepper.whatsappHelp, // índice 2

    // eSIM
    t.page3.stepper.esim, // índice 3
    t.page3.stepper.installEsim, // índice 4
    t.page3.stepper.installEsimDesc, // índice 5
    currentUserConfigs?.esim_pdf ? currentUserConfigs?.esim_pdf : '', // índice 6

    // Portabilidade
    t.page3.stepper.portabilityTitle, // índice 7
    t.page3.stepper.schedulePortability, // índice 8
    t.page3.stepper.portabilityWarning, // índice 9
    t.page3.stepper.whichPhoneTransfer, // índice 10
    t.page3.stepper.whichOperator, // índice 11
    t.page3.stepper.confirmEverything, // índice 12
    t.page3.stepper.brandFallback, // índice 13 - nome da marca
    t.page3.stepper.leaving, // índice 14
    t.page3.stepper.entering, // índice 15
    t.page3.stepper.attention, // índice 16
    t.page3.stepper.attentionText, // índice 17
    t.page3.stepper.allDone, // índice 18
    t.page3.stepper.portabilityProcessNote, // índice 19
    currentUserConfigs?.esim ? t.page3.stepper.esimInstructions : t.page3.stepper.chipInstructions, // índice 20
    t.page3.stepper.followingSmsConfirm, // índice 21
    // O índice 22 será o número do WhatsApp, fornecido em variables.text[22]
  ]
  const { text } = variables || {}
  const mergedArray = text
    ? text.map((value, index) => (value !== undefined && value !== '' ? value : defaultTextArray[index]))
    : defaultTextArray

  // Obter o número do WhatsApp de variables.text[22], ou usar o padrão
  const defaultWhatsAppText = 'Ol%C3%A1!%20Gostaria%20de%20tirar%20algumas%20d%C3%BAvidas.'
  const whatsappNumber = socials?.whatsapp
  const whatsappText = defaultWhatsAppText
  mergedArray[1] = `https://wa.me/${whatsappNumber}?text=${whatsappText}`

  /* STEP 1 */
  const buildYourPlanText = { text: [t.page3.stepper.buildYourPlan, t.page3.stepper.buildYourPlanDone] }
  /* STEP 2 */
  const installEsimText = { text: [t.page3.stepper.installEsimTitle, t.page3.stepper.installEsimComplete] }
  const esimModalTextArray = {
    text: [mergedArray[3], mergedArray[4], mergedArray[5], mergedArray[6], mergedArray[1], mergedArray[2]]
  }
  const modalClickEsim = () => {
    setStep2('completed')
    setStep2Modal(false)
    if (configList.length > 0) {
      const nextIndex = configList.findIndex((item) => item === 'step2') + 1
      if (configList[nextIndex] === 'step3') {
        step3 !== 'completed' && setStep3('active')
      } else if (configList[nextIndex] === 'step4') {
        step4 !== 'completed' && setStep4('active')
      } else {
        if (currentPath !== 'pedido-finalizado') navigate('/pedido-finalizado')
      }
    }
  }
  /* STEP 3 */
  const brandName = pageTitle ? pageTitle.split(" ")[0] : t.page3.stepper.scheduleSubtitleFallbackBrand
  const schedulePortability = { text: [t.page3.stepper.scheduleTitle, `${t.page3.stepper.scheduleSubtitlePrefix} ${brandName}`] }
  const portabilityModalTextArray = {
    text: [
      mergedArray[7],
      mergedArray[8],
      mergedArray[9],
      mergedArray[10],
      mergedArray[11],
      mergedArray[12],
      mergedArray[13],
      mergedArray[14],
      mergedArray[15],
      mergedArray[16],
      mergedArray[17],
      mergedArray[18],
      mergedArray[19],
      mergedArray[20],
      mergedArray[21],
      mergedArray[1],
      mergedArray[2],
    ]
  }
  const modalClickPortability = () => {
    setStep3('completed')
    setStep3Modal(false)
    if (configList.length > 0) {
      const nextIndex = configList.findIndex((item) => item === 'step3') + 1
      if (configList[nextIndex] === 'step4') {
        step4 !== 'completed' && setStep4('active')
      } else {
        if (currentPath !== 'pedido-finalizado') navigate('/pedido-finalizado')
      }
    }
  }
  /* STEP 4 */
  const smartControlContract = { text: [t.page3.stepper.smartControlTitle, t.page3.stepper.smartControlSubtitle] }
  const modalClickSmartControl = () => {
    setStep4('completed')
    setStep4Modal(false)
    if (currentPath !== 'pedido-finalizado') navigate('/pedido-finalizado')
  }
  /* STEP 5 */
  const whatsappConfig = {
    text: [t.page3.stepper.doubts, t.page3.stepper.doubtsSubtitle]
  }

  const configList: string[] = []
  const esim = currentUserConfigs?.esim
  const portability = currentUserConfigs?.portabilidade
  const smartControl = false
  if (esim) configList.push('step2')
  if (portability) configList.push('step3')
  if (smartControl) configList.push('step4')

  const modalOpen = step2Modal || step3Modal || step4Modal ? true : false
  if (modalOpen) {
    document.documentElement.style.overflowY = 'hidden'
  } else {
    document.documentElement.style.overflowY = ''
  }

  useEffect(() => {
    setStep3(esim ? 'disabled' : 'active')
    setStep4(esim || portability ? 'disabled' : 'active')
  }, [esim, portability])

  useEffect(() => {
    const param = location.pathname.split('/')[1]
    setCurrentPath(param)
  }, [location])

  return (
    <Grid container item className={name ? `${name} stepper-config` : "stepper-config"}>
      <Grid container item className="completed step step-1" xs={12}>
        <StepDefault
          name="build-your-plan"
          variables={buildYourPlanText}
          StepIcon={CheckIcon}
          StatusIcon={CheckIcon}
        />
      </Grid>
      
      {!loadingUserConfigs && (
        <>
          {esim && (
            <>
              <Grid
                container
                item
                className={`${step2} step step-2`}
                xs={12}
                onClick={step2 !== 'disabled' ? () => setStep2Modal(true) : () => {}}
              >
                <StepDefault
                  name="install-esim"
                  variables={installEsimText}
                  StepIcon={ESimIcon}
                  StatusIcon={step2 === 'completed' ? CheckIcon : RightArrow}
                />
              </Grid>
              {step2Modal && <ESimModal variables={esimModalTextArray} onClick={modalClickEsim} />}
            </>
          )}
          {portability && (
            <>
              <Grid
                container
                item
                className={`${step3} step step-3`}
                xs={12}
                onClick={step3 !== 'disabled' ? () => setStep3Modal(true) : () => {}}
              >
                <StepDefault
                  name="schedule-portability"
                  variables={schedulePortability}
                  StepIcon={PortabilityIcon}
                  StatusIcon={step3 === 'completed' ? CheckIcon : RightArrow}
                />
              </Grid>
              {step3Modal && (
                <PortabilityModal
                  variables={portabilityModalTextArray}
                  onClick={modalClickPortability}
                  closeModal={() => setStep3Modal(false)}
                />
              )}
            </>
          )}
          {smartControl && (
            <>
              <Grid
                container
                item
                className={`${step4} step step-4`}
                xs={12}
                onClick={step4 !== 'disabled' ? () => setStep4Modal(true) : () => {}}
              >
                <StepDefault
                  name="smart-control-contract"
                  variables={smartControlContract}
                  StepIcon={SmartControlIcon}
                  StatusIcon={step4 === 'completed' ? CheckIcon : RightArrow}
                />
              </Grid>
              {step4Modal && <SmartControl onClick={modalClickSmartControl} />}
            </>
          )}
        </>
      )}

      <Link
        className="active step step-5"
        style={{ display: mergedArray[0] }}
        href={mergedArray[1]}
        target="_blank"
        rel="noreferrer"
      >
        <StepDefault
          name="whatsapp-config"
          variables={whatsappConfig}
          StepIcon={WhatsAppIcon}
          StatusIcon={RightArrow}
        />
      </Link>
    </Grid>
  )
}